import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RiunioneGiudiziForm } from '../../../form/riunione-giudizi-form';
import { FascicoloFullResponse } from '../../../models/dto/fascicolo-full-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloGiudiziale } from '../../../models/fascicolo/fascicolo-giudiziale';

@Component({
    selector: 'div [riunione-giudizi-form-edit]',
  templateUrl: '../../../form/riunione-giudizi-form.html'
})

export class RiunioneGiudiziEditComponent extends RiunioneGiudiziForm implements OnInit {

  @Output() onReturn: EventEmitter<FascicoloFull> = new EventEmitter<FascicoloFull>();

  ngOnInit() {
    this.setTitle('Modifica dati riunione di giudizi');
    this.isInserimento(false);
  }

  getRequest() {

  }

  datiRiunione(response: FascicoloFullResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.fascicolo);
    }
  }

  inizializza(fascicolo, fascicoliRiuniti: FascicoloFull[]) {
    this.fascicoloCapofila = <FascicoloGiudiziale>fascicolo;
    this.fascicoliRiuniti = fascicoliRiuniti;
    this.createForm();
  }

}
